import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const getUserRole = () => localStorage.getItem("role") || "user";

const useAuthToken = () => {
  const token = localStorage.getItem("token");
  const auth = token !== null && token !== `Bearer ${undefined}`;

  const navigate = useNavigate();

  useEffect(() => {
    const isTokenValid = () => {
      if (token && auth) {
        var base64Url = token.split(".")[1];
        var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
        var jsonPayload = decodeURIComponent(
          window
            .atob(base64)
            .split("")
            .map(function (c) {
              return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join("")
        );
        const tokenData = JSON.parse(jsonPayload);
     
        const tokenExpiration = tokenData.exp * 1000;
        const currentTime = Date.now();
        return currentTime <= tokenExpiration;
      }
      return false;
    };
    if (!isTokenValid()) {
      localStorage.removeItem("token");
      navigate("/login");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);
  return token;
};

export default useAuthToken;
